import { createSelector } from 'reselect'
import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoData = state => state.interactiveVideo

const draftAutosubmitSelector = questionUid => createSelector(
	[ interactiveVideoData, userCredentialsSelector],
	( interactiveVideo, userCredentials ) => ({
		jwt: userCredentials.interactiveVideo,
		mediaSessionUid: interactiveVideo.uid,
		participantUid: interactiveVideo.participantUid,
		draft: interactiveVideo.drafts[questionUid],
	})
)

export default draftAutosubmitSelector
